type ConfigValues = Record<string, string | null | undefined>;

export function resolveBasePath(): string {
  const runtimeConfig = (globalThis as { __RUNTIME_CONFIG__?: ConfigValues }).__RUNTIME_CONFIG__;
  const buildConfig = import.meta.env as unknown as ConfigValues;

  const basePath = runtimeConfig?.VITE_BASE_PATH ?? buildConfig.VITE_BASE_PATH ?? runtimeConfig?.VITE_BASE_URL ?? buildConfig.VITE_BASE_URL ?? "";

  const trimmed = basePath.replace(/\\/g, "/").replace(/^\/+|\/+$/g, "");

  return trimmed === "" ? "" : `/${trimmed}`;
}
